import React, {useEffect, useState} from 'react';
import Link from 'next/link';
import {useRouter} from 'next/router';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import Skeleton from 'react-loading-skeleton'
import {AccountingHelper} from '../helpers/AccountingHelper';
import HeaderProfileDropdown from './components/HeaderProfileDropdown';
import {Col, Dropdown, Layout, Menu, Row} from 'antd';
import SVG from 'react-inlinesvg';
import {FiInstagram} from 'react-icons/fi'
import {RiArrowDownSLine} from 'react-icons/ri'
import {FaRss, FaTelegramPlane} from 'react-icons/fa'
import {MdKeyboardArrowLeft} from 'react-icons/md';

import ThemeSwitch from '../common/ThemeSwitch';
import Goftino from './components/Goftino';
import Announce from '../common/Announce';
import ImgTheme from '../common/ImgTheme';
import AppFooter from './AppFooter';
import Api from 'constants/Api';

const AppLayout = ({
                       disableFooter,
                       disableHeader,
                       disableDrawer,
                       layoutClass,
                       currentPath,
                       children,
                       clearBackground
                   }) => {
    const dispatch = useDispatch()
    const router = useRouter()
    const {t} = useTranslation();
    const {Header, Content, Sider, Footer} = Layout;
    const [menuCollapsed, setMenuCollapsed] = useState(disableDrawer);
    const [showDropDown, setShowDropDown] = useState(false);

    const UserState = useSelector((state) => state.User);
    const ThemeState = useSelector(state => state.Theme)

    const getMenuItem = (label, key, icon, children) => {
        return {
            key,
            icon,
            children,
            label,
        };
    }

    let menuItems = [
        getMenuItem(
            <Link href={`/`} as={`/`}>
                <a title={t('dashboard')}>
                    {t('dashboard')}
                </a>
            </Link>,
            'home',
            <ImgTheme src={'/images/sidebar-navigation/home.svg'}/>,
            null
        ),
        getMenuItem(
            <Link href={`/markets`} as={`/markets`}>
                <a title={'لیست ارزها'}>
                    لیست ارزها
                </a>
            </Link>,
            'markets',
            <ImgTheme src={'/images/sidebar-navigation/markets.svg'}/>,
            null
        ),
        getMenuItem(
            <Link href={`/quick-trade`} as={`/quick-trade`}>
                <a title={t('quick_access_quick_order')}>
                    {t('quick_access_quick_order')}
                </a>
            </Link>,
            'quick-trade',
            <ImgTheme src={'/images/sidebar-navigation/quick-trade.svg'}/>,
            null
        ),
        getMenuItem(
            <Link href={`/wallets`} as={`/wallets`}>
                <a title={t('wallets')}>
                    {t('wallets')}
                </a>
            </Link>,
            'wallets',
            <ImgTheme src={'/images/sidebar-navigation/wallets.svg'}/>,
            null
        ),
        getMenuItem(
            <Link href={`/active-trades`} as={`/active-trades`}>
                <a title={t('quick_access_active_trades')}>
                    {t('quick_access_active_trades')}
                </a>
            </Link>,
            'active-trades',
            <ImgTheme src={'/images/sidebar-navigation/active-trades.svg'}/>,
            null
        ),
        getMenuItem(
            t('accounting'),
            'accounting',
            <ImgTheme src={'/images/sidebar-navigation/accounting.svg'}/>,
            [
                getMenuItem(
                    <Link href={`/wallets/irt/deposit`} as={`/wallets/irt/deposit`}>
                        <a title={t('quick_access_deposit_fiat')}>
                            {t('quick_access_deposit_fiat')}
                        </a>
                    </Link>,
                    'deposit-fiat',
                    null,
                    null
                ),
                getMenuItem(
                    <Link href={`/wallets`} as={`/wallets`}>
                        <a title={t('wallet_withdraw')}>
                            {t('wallet_withdraw')}
                        </a>
                    </Link>,
                    'withdraw',
                    null,
                    null
                ),
                getMenuItem(
                    <Link href={`/credit-card`} as={`/credit-card`}>
                        <a title={t('quick_access_add_card')}>
                            {t('quick_access_add_card')}
                        </a>
                    </Link>,
                    'credit-card',
                    null,
                    null
                )
            ]
        ),
        getMenuItem(
            t('quick_access_history'),
            'history',
            <ImgTheme src={'/images/sidebar-navigation/history.svg'}/>,
            [
                getMenuItem(
                    <Link href={`/history/trades`} as={`/history/trades`}>
                        <a title={t('quick_access_history_trades')}>
                            {t('quick_access_history_trades')}
                        </a>
                    </Link>,
                    'history-trades',
                    null,
                    null
                ),
                getMenuItem(
                    <Link href={`/history/fiat`} as={`/history/fiat`}>
                        <a title={t('quick_access_history_deposit_withdraw_fiat')}>
                            {t('quick_access_history_deposit_withdraw_fiat')}
                        </a>
                    </Link>,
                    'history-fiat',
                    null,
                    null
                ),
                getMenuItem(
                    <Link href={`/history/crypto`} as={`/history/crypto`}>
                        <a title={t('quick_access_history_deposit_withdraw_crypto')}>
                            {t('quick_access_history_deposit_withdraw_crypto')}
                        </a>
                    </Link>,
                    'history-crypto',
                    null,
                    null
                )
            ]
        ),
        getMenuItem(
            t('quick_access_profile'),
            'profile',
            <ImgTheme src={'/images/quick-access/profile.svg'}/>,
            [
                getMenuItem(
                    <Link href={`/profile`} as={`/profile`}>
                        <a title={t('quick_access_profile')}>
                            {t('quick_access_profile')}
                        </a>
                    </Link>,
                    'profile',
                    null,
                    null
                ),
                getMenuItem(
                    <Link href={`/security`} as={`/security`}>
                        <a title={t('security')}>
                            {t('security')}
                        </a>
                    </Link>,
                    'security',
                    null,
                    null
                ),
                getMenuItem(
                    <Link href={`/security/change-password`} as={`/security/change-password`}>
                        <a title={t('quick_access_change_password')}>
                            {t('quick_access_change_password')}
                        </a>
                    </Link>,
                    'security-change-password',
                    null,
                    null
                )
            ],
        ),
        getMenuItem(
            <Link href={`/invite`} as={`/invite`}>
                <a title={t('quick_access_invite')}>
                    {t('quick_access_invite')}
                </a>
            </Link>,
            'invite',
            <ImgTheme src={'/images/sidebar-navigation/invite.svg'}/>,
            null
        ),
    ]

    const selectedKey = () => {
        try {
            return currentPath === '/' ? 'home' : currentPath === '/' ? '' : currentPath.substr(1).split('/')[0]
        } catch (e) {
            return ''
        }
    }

    const IncreasePlanAnnounce = info => {
        if (typeof info?.plan !== undefined && !_.isNull(info?.plan)) {
            if(info.info.waiting_for_upgrade === AccountingHelper.waitingForUpgradeStatus.REQUESTED) {
                return <Announce type={'warning'}
                                 singleRow={true}
                                 className={'min-w-[384px]'}
                                 innerClassName={'flex justify-between py-[8px]'}
                                 textClassName={'mt-0 font-semibold'}
                                 text={<p className={'mb-0'}>احراز در دست بررسی است.</p>}
                                 link={{href: '/plan', as: '/plan'}}
                                 linkIcon={<MdKeyboardArrowLeft className={'text-warn'} size={18}/>}
                />
            }
            else if (info.plan.order === AccountingHelper.FIRST_PLAN) {
                return <Announce type={'warning'}
                                 singleRow={true}
                                 className={'min-w-[384px]'}
                                 innerClassName={'flex justify-between py-[8px]'}
                                 textClassName={'mt-0 font-semibold'}
                                 text={<p className={'mb-0'}>لطفا برای استفاده از خدمات، احراز هویت را تکمیل کنید.</p>}
                                 link={{href: '/plan', as: '/plan'}}
                                 linkIcon={<MdKeyboardArrowLeft className={'text-warn'} size={18}/>}
                />
            } else if (info.plan.order === AccountingHelper.MIDDLE_PLAN) {
                return <Announce type={'warning'}
                                 singleRow={true}
                                 className={'min-w-[384px]'}
                                 innerClassName={'flex justify-between py-[8px]'}
                                 textClassName={'mt-0 font-semibold'}
                                 text={<p className={'mb-0'}>برای افزایش سقف واریز/برداشت، احراز سطح ۲ را تکمیل کنید.</p>}
                                 link={{href: '/plan', as: '/plan'}}
                                 linkIcon={<MdKeyboardArrowLeft className={'text-warn'} size={18}/>}
                />
            } else if (!info.info.is_email_verified) {
                if(info.info.email) {
                    return <Announce type={'warning'}
                                     singleRow={true}
                                     className={'min-w-[384px]'}
                                     innerClassName={'flex justify-between py-[8px]'}
                                     textClassName={'mt-0'}
                                     text={<p className={'mb-0'}>ایمیل شما نیازمند تایید است.</p>}
                                     link={{href: '/security/email', as: '/security/email'}}
                                     linkIcon={<MdKeyboardArrowLeft className={'text-warn'} size={18}/>}
                    />
                } else {
                    return <Announce type={'warning'}
                                     singleRow={true}
                                     className={'min-w-[384px]'}
                                     innerClassName={'flex justify-between py-[8px]'}
                                     textClassName={'mt-0'}
                                     text={<p className={'mb-0'}>لطفا ایمیل خود را ثبت و تایید کنید.</p>}
                                     link={{href: '/security/email', as: '/security/email'}}
                                     linkIcon={<MdKeyboardArrowLeft className={'text-warn'} size={18}/>}
                    />
                }
            }
        }
    }

    useEffect(() => {
        setMenuCollapsed(disableDrawer)
    }, [disableDrawer])

    return <Layout className={`layout ${layoutClass}`}
                   style={{minHeight: '100vh'}}>
        <Sider trigger={null}
               className={'desktop-only'}
               collapsible
               collapsed={menuCollapsed}>
            <div className={'logo-container'}>
                {
                    ThemeState.theme === 'dark' ?
                        <img src={'/images/logo/logo-minimal.svg'} alt={'لوگو پینگی'}/> :
                        <img src={'/images/logo/logo-minimal.svg'} alt={'لوگو پینگی'}/>
                }
            </div>
            <Menu mode={'inline'} defaultSelectedKeys={['home']}
                  items={menuItems}
                  inlineCollapsed={menuCollapsed}
                  selectedKeys={[selectedKey(currentPath)]}/>
            <div className={'social-container'}>
                <a href="https://www.instagram.com/pingi_ir/"><FiInstagram/></a>
                <a href="https://t.me/Pingi_ir"><FaTelegramPlane/></a>
                <a href={`https://pingi.co/blog`}><FaRss/></a>
            </div>
        </Sider>

        <Layout
            className={`site-layout site-layout-background ${menuCollapsed ? 'site-layout--small-sider' : 'site-layout--big-sider'}`}>
            <Content
                style={{
                    minHeight: 280,
                }}>
                {
                    !disableHeader &&
                    <div className={'main-header__container'}>
                        <Header className={'main-header'}>
                            <Row>
                                <Col className={'main-header__right'} md={9}>
                                    <div className={
                                        'cursor-pointer h-full flex items-center justify-center rounded-[8px] ' +
                                        'w-[32px]'
                                    }
                                         onClick={() => setMenuCollapsed(!menuCollapsed)}>
                                        {
                                            menuCollapsed ? <SVG src={'/images/icons/drawer-close.svg'}/>
                                                : <SVG src={'/images/icons/drawer.svg'}/>
                                        }
                                    </div>
                                    {
                                        IncreasePlanAnnounce(UserState)
                                    }
                                </Col>
                                <Col className={'main-header__buttons align-middle-left'} flex={'auto'}>
                                    <div className={'flex flex-row gap-[12px]'}>
                                        <div className={'flex items-center !text-xs'}>
                                            <ThemeSwitch/>
                                        </div>
                                        <div className={'main-header__actions min-w-[240px]'}>
                                            {
                                                UserState?.info ?
                                                    <Dropdown
                                                        trigger={['click']}
                                                        overlay={() => {
                                                            return <HeaderProfileDropdown
                                                                setShowDropDown={setShowDropDown}/>
                                                        }}
                                                        onOpenChange={data => {
                                                            setShowDropDown(data)
                                                        }}
                                                        open={showDropDown}>
                                                        <div
                                                            className={
                                                                'flex items-center justify-between h-[40px] rounded-[4px] bg-[var(--color-layer-two)] ' +
                                                                'w-full px-[12px] cursor-pointer'}>
                                                            <div className={'flex items-center gap-2'}>
                                                                <SVG src={'/images/icons/navigation-profile.svg'}
                                                                     className={'h-[18px]'}/>
                                                                <span>{`${UserState.info.first_name} ${UserState.info.last_name}`}</span>
                                                            </div>
                                                            <RiArrowDownSLine className={'transition-[0.5s]'}
                                                                              style={{transform: showDropDown ? 'rotate(180deg)' : 'rotate(0deg)'}}/>
                                                        </div>
                                                    </Dropdown>
                                                    :
                                                    <Skeleton
                                                        baseColor={'var(--place-holder-one)'}
                                                        highlightColor={'var(--place-holder-two)'}
                                                        height={40}/>
                                            }
                                        </div>
                                        <div className={'main-header__plan'}>
                                            {
                                                UserState?.plan ?
                                                    <Link href={'/profile'} as={'/profile'}>
                                                        <a>
                                                            <div className={'flex items-center gap-2 px-6'}>
                                                                <SVG src={'/images/icons/head-plans.svg'}
                                                                     className={'h-[18px]'}/>
                                                                {UserState.plan.user_level}
                                                            </div>
                                                        </a>
                                                    </Link>
                                                    :
                                                    <Skeleton
                                                        baseColor={'var(--place-holder-one)'}
                                                        highlightColor={'var(--place-holder-two)'}
                                                        height={40}/>
                                            }
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Header>
                    </div>
                }
                {children}
            </Content>
            <AppFooter disableFooter={disableFooter}/>
        </Layout>
        <Goftino open={null}/>
    </Layout>
};

export default AppLayout
